const NOTIFICATION_POSITION = [
  "topLeft",
  "topRight",
  "bottomLeft",
  "bottomRight"
];
export { NOTIFICATION_POSITION };
